import { BidAskToggle } from 'components/dashboard/DashboardOpportunities'
import { Box } from '@forgeglobal/design-framework'
import { OpportunitiesTables } from 'components/dashboard/OpportunitiesTables'
import { useBaseIssuerAccountQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment, useState } from 'react'

interface IssuerOpportunitiesProps {
  issuerId: string
}

export const IssuerOpportunities: React.FC<IssuerOpportunitiesProps> = ({ issuerId }) => {
  const [selectedTradeIntentTypes, setSelectedTradeIntentTypes] = useState(['bids', 'asks'])

  const { data } = useBaseIssuerAccountQuery({
    variables: {
      issuerId,
    },
  })

  const companyId = data?.account.issuer_account?.company.id

  const handleChange = (e: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => {
    setSelectedTradeIntentTypes(value)
  }

  return (
    <Fragment>
      <Box mb={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <BidAskToggle value={selectedTradeIntentTypes} onChange={handleChange} />
      </Box>

      <OpportunitiesTables displayedTables={selectedTradeIntentTypes} companyId={companyId} tableVariant={'issuer'} />
    </Fragment>
  )
}
